import ProgressDots from './ProgressDots'

export default ProgressDots
